import { makeModule } from '@codium/codium-vue'

export const storeModule = makeModule('mediaOwnerScreenTags', {
  parent: 'lists'
})
